const translations = {
  "en": {
    "Couldn't create note. Try again.": "Couldn't create note. Try again.",
    "Ed is working on it...": "Ed is working on it...",
    "New tracker created. Ed will post updates on Desk.": "New tracker created. Ed will post updates on Desk.",
    "New tracker created. Ed will post updates on Track.": "New tracker created. Ed will post updates on Track.",
    "View": "View"
  },
  "zh-tw": {
    "Couldn't create note. Try again.": "無法建立筆記。請再試一次。",
    "Ed is working on it...": "Ed 正在處理……",
    "New tracker created. Ed will post updates on Desk.": "新追蹤器已建立。Ed 會在 Desk 上發佈更新。",
    "New tracker created. Ed will post updates on Track.":
      "新追蹤器已建立。Ed 會在「追蹤」頁發佈更新。",
    "View": "查看"
  }
};

export default translations;
